// Import and re-export the api object from requestInterceptor.js
// This ensures consistency across the application

import { api } from './requestInterceptor';

// Add enhanced logging only for menu permissions endpoint
const originalGet = api.get;
api.get = function(url, config) {
  if (url === '/auth/menu-permissions') {
    console.log('Making menu permissions request to:', url);
  }
  return originalGet(url, config).then(response => {
    if (url === '/auth/menu-permissions') {
      console.log('Menu Permissions Response:', response.data);
    }
    return response;
  }).catch(error => {
    if (url === '/auth/menu-permissions') {
      console.error('Menu Permissions Error:', error);
    }
    throw error;
  });
};

export default api;
